<template>

  <SideBarAsideUser/>

  <div class="content pd-0" style="border: 1px solid #ccc;">
    <div class="content-header">
      <div class="content-search">
        <i data-feather="search"></i>
        <input type="search" class="form-control" placeholder="Search...">
      </div>
      <nav class="nav">
        <a href="" class="nav-link"><i data-feather="help-circle"></i></a>
        <a href="" class="nav-link"><i data-feather="grid"></i></a>
        <a href="" class="nav-link"><i data-feather="align-left"></i></a>
      </nav>
    </div><!-- content-header -->
    <div class="content-body">
      <div class="container pd-x-0">
        <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
          <div>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page"> User Corner</li>
              </ol>
            </nav>
            <h4 class="mg-b-0 tx-spacing--1"> Watch Video </h4>
          </div>
          <div class="d-none d-md-block">
            <button class="btn btn-sm pd-x-15 btn-white btn-uppercase"><i data-feather="mail" class="wd-10 mg-r-5"></i>
              Email
            </button>
            <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"><i data-feather="printer"
                                                                                 class="wd-10 mg-r-5"></i> Print
            </button>
            <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><i data-feather="file"
                                                                                   class="wd-10 mg-r-5"></i> Generate
              Report
            </button>
          </div>
        </div>





        <div class="row no-gutters" style="gap:0; margin-left:0; margin-right:0;">

          <!-- ══════════════════════════════════════════
               LEFT — main video column
          ══════════════════════════════════════════ -->
          <div class="col-lg-8 layout-col-main" style="padding-right: 20px;">

            <div class="video-card">

              <!-- ── YouTube embed (16:9) ── -->
              <div class="video-embed-wrap">
                <div class="embed-responsive embed-responsive-16by9">
                  <iframe
                      class="embed-responsive-item"
                      src="https://www.youtube.com/embed/2tC20psOpK0?rel=0&modestbranding=1"
                      title="Build and Deploy an Amazing 3D Web Developer Portfolio"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen>
                  </iframe>
                </div>
              </div>

              <!-- ── Author row ── -->
              <div class="d-flex align-items-center justify-content-between pd-x-20 pd-b-16" style="padding-top: 22px;">
                <div class="d-flex align-items-center" style="gap:13px;">
                  <img
                      src="https://images.unsplash.com/photo-1517841905240-472988babdf9?w=80&h=80&auto=format&fit=crop&q=80"
                      class="author-avatar"
                      alt="Monroe Parker"
                  >
                  <div>
                    <p class="tx-14 tx-semibold tx-color-01 mg-b-0">Monroe Parker</p>
                    <p class="tx-12 tx-color-03 mg-b-0">2 hours ago</p>
                  </div>
                </div>
                <!-- DashForge dropdown -->
                <div class="dropdown">
                  <a href="#" class="tx-color-04 tx-18" data-toggle="dropdown" aria-expanded="false">
                    <i class="fas fa-ellipsis-h"></i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <a class="dropdown-item" href="#"><i class="fas fa-bookmark mg-r-8 tx-color-03"></i>Save</a>
                    <a class="dropdown-item" href="#"><i class="fas fa-share mg-r-8 tx-color-03"></i>Share</a>
                    <a class="dropdown-item" href="#"><i class="fas fa-flag mg-r-8 tx-color-03"></i>Report</a>
                  </div>
                </div>
              </div>

              <!-- ── Description ── -->
              <div class="pd-x-20" style="padding-bottom: 20px;">
                <p class="tx-14 tx-color-02 mg-b-0" style="line-height:1.65;">
                  Photography is the art of capturing light with a camera. It can be used to create images that tell stories, express emotions, or document reality. it can be fun, challenging, or rewarding. It can also be a hobby, a profession, or a passion. 📷
                </p>
              </div>

              <!-- ── Reaction bar ── -->
              <div class="d-flex align-items-center justify-content-between pd-x-20 reaction-bar" style="padding-top: 18px; padding-bottom: 20px;">
                <!-- Left: like + comment counts -->
                <div class="d-flex align-items-center" style="gap:8px;">
                  <a class="reaction-pill" href="#">
                    <span style="font-size:16px;">❤️</span>
                    <span>1,300</span>
                  </a>
                  <a class="reaction-pill" href="#">
                    <i class="fas fa-comment-dots tx-color-03" style="font-size:14px;"></i>
                    <span>260</span>
                  </a>
                </div>
                <!-- Right: send + share -->
                <div class="d-flex align-items-center" style="gap:2px;">
                  <button class="react-icon-btn" title="Send">
                    <i class="fas fa-paper-plane"></i>
                  </button>
                  <button class="react-icon-btn" title="Share">
                    <i class="fas fa-share-nodes"></i>
                  </button>
                </div>
              </div>

              <!-- ── Divider ── -->
              <hr class="mg-x-20 mg-y-0" style="margin-top:0;margin-bottom:0;">

              <!-- ── Comments list ── -->
              <div class="pd-x-20" style="padding-top: 24px; padding-bottom: 16px;">

                <!-- Comment 1 -->
                <div class="d-flex align-items-start" style="gap:14px; margin-bottom:28px;">
                  <img src="https://images.unsplash.com/photo-1517841905240-472988babdf9?w=80&h=80&auto=format&fit=crop&q=80" class="comment-avatar" alt="Monroe Parker">
                  <div>
                    <p class="tx-13 tx-semibold tx-color-01 mg-b-1">Monroe Parker</p>
                    <p class="tx-13 tx-color-02 mg-b-0">What a beautiful photo! I love it. 😍</p>
                  </div>
                </div>

                <!-- Comment 2 -->
                <div class="d-flex align-items-start" style="gap:14px; margin-bottom:28px;">
                  <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=80&h=80&auto=format&fit=crop&q=80" class="comment-avatar" alt="John Michael">
                  <div>
                    <p class="tx-13 tx-semibold tx-color-01 mg-b-1">John Michael</p>
                    <p class="tx-13 tx-color-02 mg-b-0">You captured the moment.😎</p>
                  </div>
                </div>

                <!-- Comment 3 -->
                <div class="d-flex align-items-start" style="gap:14px; margin-bottom:28px;">
                  <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&auto=format&fit=crop&q=80" class="comment-avatar" alt="James Lewis">
                  <div>
                    <p class="tx-13 tx-semibold tx-color-01 mg-b-1">James Lewis</p>
                    <p class="tx-13 tx-color-02 mg-b-0">What a beautiful photo! I love it. 😍</p>
                  </div>
                </div>

                <!-- Comment 4 -->
                <div class="d-flex align-items-start" style="gap:14px; margin-bottom:28px;">
                  <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&auto=format&fit=crop&q=80" class="comment-avatar" alt="Martin Gray">
                  <div>
                    <p class="tx-13 tx-semibold tx-color-01 mg-b-1">Martin Gray</p>
                    <p class="tx-13 tx-color-02 mg-b-0">You captured the moment.😎</p>
                  </div>
                </div>

                <!-- More Comment toggle -->
                <a href="#" class="more-comment-link mg-b-16 d-inline-flex" id="moreCommentBtn">
                  <i class="fas fa-chevron-down" style="font-size:11px;"></i>
                  More Comment
                </a>

                <!-- Hidden extra comments (revealed on "More Comment" click) -->
                <div id="extraComments" style="display:none;">
                  <div class="d-flex align-items-start" style="gap:14px; margin-bottom:28px;">
                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=80&h=80&auto=format&fit=crop&q=80" class="comment-avatar" alt="Rachel Chen">
                    <div>
                      <p class="tx-13 tx-semibold tx-color-01 mg-b-1">Rachel Chen</p>
                      <p class="tx-13 tx-color-02 mg-b-0">Absolutely stunning composition! 🔥</p>
                    </div>
                  </div>
                  <div class="d-flex align-items-start" style="gap:14px; margin-bottom:28px;">
                    <img src="https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=80&h=80&auto=format&fit=crop&q=80" class="comment-avatar" alt="Priya Singh">
                    <div>
                      <p class="tx-13 tx-semibold tx-color-01 mg-b-1">Priya Singh</p>
                      <p class="tx-13 tx-color-02 mg-b-0">The lighting here is incredible 😍</p>
                    </div>
                  </div>
                </div>

              </div><!-- /comments list -->

              <!-- ── Add Comment row ── -->
              <div class="comment-input-row">
                <img
                    src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&auto=format&fit=crop&q=80"
                    class="comment-input-avatar"
                    alt="You"
                >
                <input
                    type="text"
                    class="form-control flex-grow-1"
                    placeholder="Add Comment...."
                >
                <button class="btn btn-outline-secondary btn-sm" style="white-space:nowrap;font-size:12px;border-radius:4px;">
                  Replay
                </button>
              </div>

            </div><!-- /video-card -->
          </div><!-- /left col -->

          <!-- ══════════════════════════════════════════
               RIGHT — Related Videos sidebar
          ══════════════════════════════════════════ -->
          <div class="col-lg-4 layout-col-aside" style="padding-left: 0;">

            <div class="related-card">
              <h6 class="related-heading">Related Videos</h6>

              <div class="related-grid">

                <!-- Related 1 -->
                <a href="#" class="rel-row">
                  <div class="rel-thumb">
                    <img src="https://images.unsplash.com/photo-1561144257-e32e8506e0b4?w=320&h=180&auto=format&fit=crop&q=80" alt="">
                    <div class="rel-play"><div class="rel-play-btn"><i class="fas fa-play" style="margin-left:1px;"></i></div></div>
                    <span class="rel-dur">10:32</span>
                  </div>
                  <div class="rel-info">
                    <p class="rel-title">Great drone jet testing range flat model show…</p>
                    <p class="rel-channel">John Michael <i class="fas fa-circle-check verified-icon"></i></p>
                    <p class="rel-meta">260K views · 1 days ago</p>
                  </div>
                </a>

                <!-- Related 2 -->
                <a href="#" class="rel-row">
                  <div class="rel-thumb">
                    <img src="https://images.unsplash.com/photo-1533106958148-daaeab8b83fe?w=320&h=180&auto=format&fit=crop&q=80" alt="">
                    <div class="rel-play"><div class="rel-play-btn"><i class="fas fa-play" style="margin-left:1px;"></i></div></div>
                    <span class="rel-dur">10:32</span>
                  </div>
                  <div class="rel-info">
                    <p class="rel-title">Exploring latest an abandoned water park in…</p>
                    <p class="rel-channel">John Michael <i class="fas fa-circle-check verified-icon"></i></p>
                    <p class="rel-meta">260K views · 1 days ago</p>
                  </div>
                </a>

                <!-- Related 3 -->
                <a href="#" class="rel-row">
                  <div class="rel-thumb">
                    <img src="https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=320&h=180&auto=format&fit=crop&q=80" alt="">
                    <div class="rel-play"><div class="rel-play-btn"><i class="fas fa-play" style="margin-left:1px;"></i></div></div>
                    <span class="rel-dur">10:32</span>
                  </div>
                  <div class="rel-info">
                    <p class="rel-title">cheese cake eggless without oven hida mari…</p>
                    <p class="rel-channel">John Michael <i class="fas fa-circle-check verified-icon"></i></p>
                    <p class="rel-meta">260K views · 1 days ago</p>
                  </div>
                </a>

                <!-- Related 4 -->
                <a href="#" class="rel-row">
                  <div class="rel-thumb">
                    <img src="https://images.unsplash.com/photo-1520637836993-5c193e8a4b20?w=320&h=180&auto=format&fit=crop&q=80" alt="">
                    <div class="rel-play"><div class="rel-play-btn"><i class="fas fa-play" style="margin-left:1px;"></i></div></div>
                    <span class="rel-dur">10:32</span>
                  </div>
                  <div class="rel-info">
                    <p class="rel-title">Amazing little girl has very talent voice vocal coach</p>
                    <p class="rel-channel">John Michael <i class="fas fa-circle-check verified-icon"></i></p>
                    <p class="rel-meta">260K views · 1 days ago</p>
                  </div>
                </a>

                <!-- Related 5 -->
                <a href="#" class="rel-row">
                  <div class="rel-thumb">
                    <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=320&h=180&auto=format&fit=crop&q=80" alt="">
                    <div class="rel-play"><div class="rel-play-btn"><i class="fas fa-play" style="margin-left:1px;"></i></div></div>
                    <span class="rel-dur">10:32</span>
                  </div>
                  <div class="rel-info">
                    <p class="rel-title">Amazing house construction from…</p>
                    <p class="rel-channel">John Michael <i class="fas fa-circle-check verified-icon"></i></p>
                    <p class="rel-meta">260K views · 1 days ago</p>
                  </div>
                </a>

                <!-- Related 6 -->
                <a href="#" class="rel-row">
                  <div class="rel-thumb">
                    <img src="https://images.unsplash.com/photo-1561144257-e32e8506e0b4?w=320&h=180&auto=format&fit=crop&q=80" alt="">
                    <div class="rel-play"><div class="rel-play-btn"><i class="fas fa-play" style="margin-left:1px;"></i></div></div>
                    <span class="rel-dur">10:32</span>
                  </div>
                  <div class="rel-info">
                    <p class="rel-title">Great drone jet testing range flat model show…</p>
                    <p class="rel-channel">John Michael <i class="fas fa-circle-check verified-icon"></i></p>
                    <p class="rel-meta">260K views · 1 days ago</p>
                  </div>
                </a>

                <!-- Related 7 -->
                <a href="#" class="rel-row">
                  <div class="rel-thumb">
                    <img src="https://images.unsplash.com/photo-1533106958148-daaeab8b83fe?w=320&h=180&auto=format&fit=crop&q=80" alt="">
                    <div class="rel-play"><div class="rel-play-btn"><i class="fas fa-play" style="margin-left:1px;"></i></div></div>
                    <span class="rel-dur">10:32</span>
                  </div>
                  <div class="rel-info">
                    <p class="rel-title">Exploring latest an abandoned water park in…</p>
                    <p class="rel-channel">John Michael <i class="fas fa-circle-check verified-icon"></i></p>
                    <p class="rel-meta">260K views · 1 days ago</p>
                  </div>
                </a>

              </div><!-- /related-grid -->
            </div><!-- /related-card -->

          </div><!-- /right col -->

        </div><!-- /row -->


      </div><!-- container -->
    </div>

  </div>

</template>


<script>
import visualizationMixin from "@/mixins/visualization-script";
import footerScriptMixin from "@/mixins/footer-script";
import serviceMixin from "@/mixins/contact-service";
import SideBarAsideUser from "../components/SideBarAsideUser.vue";
// import axios from "axios";  // enable later

export default {
  name: 'VideoDetail',
  components: {SideBarAsideUser},
  mixins: [visualizationMixin, footerScriptMixin, serviceMixin],

  data() {
    return {
      offset: 0,
      isShifted: false,
      columnWidth: 0,
      suggestionVideos: [
        {
          id: 1,
          title: "Amazing House Construction From Foundation To Last Detail",
          thumbnailUrl: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=640&h=360&auto=format&fit=crop&q=80",
          duration: "12:21",
          channelName: "Jesse Steeve",
          views: "156.9K",
          uploadedAgo: "27 weeks ago",
          description: "Full house construction documentary."
        },
        {
          id: 2,
          title: "Great Drone Jet Testing Range Flat Model Show With Advance",
          thumbnailUrl: "https://images.unsplash.com/photo-1561144257-e32e8506e0b4?w=640&h=360&auto=format&fit=crop&q=80",
          duration: "09:15",
          channelName: "John Michael",
          views: "98.1K",
          uploadedAgo: "12 weeks ago",
          description: "Drone testing and model showcase."
        },
        {
          id: 3,
          title: "Exploring Latest An Abandoned Water Park In China City",
          thumbnailUrl: "https://images.unsplash.com/photo-1533106958148-daaeab8b83fe?w=640&h=360&auto=format&fit=crop&q=80",
          duration: "18:44",
          channelName: "Monroe Parker",
          views: "202K",
          uploadedAgo: "5 months ago",
          description: "Urban exploration documentary."
        },
        {
          id: 4,
          title: "Exploring Latest An Abandoned Water Park In China City",
          thumbnailUrl: "https://images.unsplash.com/photo-1533106958148-daaeab8b83fe?w=640&h=360&auto=format&fit=crop&q=80",
          duration: "18:44",
          channelName: "Monroe Parker",
          views: "202K",
          uploadedAgo: "5 months ago",
          description: "Urban exploration documentary."
        }

      ],

      // ================================
      // USER VIDEO LIST (Rows)
      // ================================
      userVideos: [
        {
          id: 101,
          title: "Great Drone Jet Testing Range Flat Model Show With Advance",
          thumbnailUrl: "https://images.unsplash.com/photo-1561144257-e32e8506e0b4?w=572&h=324&auto=format&fit=crop&q=80",
          duration: "12:21",
          channelName: "John Michael",
          views: "156.9K",
          uploadedAgo: "27 weeks ago",
          description: "consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,"
        },
        {
          id: 102,
          title: "Exploring Latest An Abandoned Water Park In China City",
          thumbnailUrl: "https://images.unsplash.com/photo-1533106958148-daaeab8b83fe?w=572&h=324&auto=format&fit=crop&q=80",
          duration: "12:21",
          channelName: "Monroe Parker",
          views: "156.9K",
          uploadedAgo: "27 weeks ago",
          description: "consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,"
        },
        {
          id: 103,
          title: "Cheese Cake Eggless Without Oven Hida Mari Cooking",
          thumbnailUrl: "https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=572&h=324&auto=format&fit=crop&q=80",
          duration: "12:21",
          channelName: "Martin Gray",
          views: "156.9K",
          uploadedAgo: "27 weeks ago",
          description: "consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,"
        }
      ]

    }
  },

  created() {
    this.footerScript();
    this.asideBarScript();

    // ====================================
    // Future: Load from Spring Boot API
    // ====================================
    /*
    axios.get('/api/videos/suggestions')
      .then(response => {
        this.suggestionVideos = response.data;
      });

    axios.get('/api/videos/user')
      .then(response => {
        this.userVideos = response.data;
      });
    */
  },
  computed: {
    carouselStyle() {
      return {
        transform: `translateX(-${this.offset}px)`
      };
    },
    arrowIconClass() {
      return this.isShifted
          ? 'fas fa-chevron-left'
          : 'fas fa-chevron-right';
    }
  },

  mounted() {
    this.calculateColumnWidth();
    window.addEventListener('resize', this.calculateColumnWidth);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.calculateColumnWidth);
  },

  methods: {
    calculateColumnWidth() {
      const track = this.$refs.carouselTrack;
      if (!track) return;
      const parentWidth = track.parentElement.offsetWidth;
      // 4 columns layout (desktop)
      this.columnWidth = parentWidth / 4;
    },

    toggleCarousel() {
      if (!this.isShifted) {
        this.offset = this.columnWidth;
        this.isShifted = true;
      } else {
        this.offset = 0;
        this.isShifted = false;
      }
    }

  }
}
</script>

<style>
@import 'https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.6.2/css/bootstrap.min.css';
@import 'http://app.wcicambridge.org/cdn/assets/css/dashforge.css';
@import '../../assets/lib/remixicon/fonts/remixicon.css';
@import '../../assets/lib/select2/css/select2.min.css';

  /*
   * New CSS only where DashForge / Bootstrap 4 has no equivalent.
   * All colour tokens (tx-color-0x), spacing (mg-* pd-*), card, btn,
   * dropdown, avatar, media-object, badge come from DashForge / BS4.
   */

body { background-color: #f0f2f5; }

/* ══════════════════════════════════════════════
   1.  16:9 RESPONSIVE IFRAME WRAPPER
      Bootstrap 4 ships .embed-responsive .embed-responsive-16by9
      — we just need the border-radius override.
══════════════════════════════════════════════ */
.video-embed-wrap {
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  background: #000;
}
.video-embed-wrap iframe { display: block; }

/* ══════════════════════════════════════════════
   2.  MAIN CARD CHROME
══════════════════════════════════════════════ */
.video-card {
  background: #fff;
  border: 1px solid #e3e7ed;
  border-radius: 8px;
  overflow: hidden;
}

/* ══════════════════════════════════════════════
   3.  AUTHOR ROW
══════════════════════════════════════════════ */
.author-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

/* ══════════════════════════════════════════════
   4.  REACTION BAR
══════════════════════════════════════════════ */
.reaction-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #f5f6fa;
  border: 1px solid #e3e7ed;
  border-radius: 30px;
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #1b2e4b;
  cursor: pointer;
  transition: background .15s;
  text-decoration: none;
}
.reaction-pill:hover { background: #eaecf4; text-decoration: none; color: #1b2e4b; }

.react-icon-btn {
  background: none;
  border: none;
  padding: 4px 6px;
  color: #596882;
  font-size: 17px;
  cursor: pointer;
  border-radius: 4px;
  transition: color .15s, background .15s;
  line-height: 1;
}
.react-icon-btn:hover { color: #1b2e4b; background: #f0f2f5; }

/* ══════════════════════════════════════════════
   5.  COMMENTS
══════════════════════════════════════════════ */
.comment-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.comment-input-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.more-comment-link {
  font-size: 13px;
  font-weight: 500;
  color: #596882;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
.more-comment-link:hover { color: #1b2e4b; text-decoration: none; }

/* ══════════════════════════════════════════════
   6.  COMMENT INPUT ROW
══════════════════════════════════════════════ */
.comment-input-row {
  border-top: 1px solid #e3e7ed;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
}
/* DashForge .form-control already styles the input */
.comment-input-row .form-control {
  border-radius: 30px;
  font-size: 13px;
  background: #f5f6fa;
  border-color: transparent;
}
.comment-input-row .form-control:focus {
  background: #fff;
  border-color: #0168fa;
  box-shadow: none;
}

/* ══════════════════════════════════════════════
   7.  RELATED VIDEOS SIDEBAR
══════════════════════════════════════════════ */
.related-card {
  background: #fff;
  border: 1px solid #e3e7ed;
  border-radius: 8px;
  overflow: hidden;
}
.related-heading {
  font-size: 14px;
  font-weight: 700;
  color: #1b2e4b;
  padding: 16px 16px 12px;
  border-bottom: 1px solid #f0f2f5;
  margin: 0;
}

/* Each related row */
.rel-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background .15s;
  text-decoration: none;
}
.rel-row:hover { background: #f8f9fc; text-decoration: none; }
.rel-row + .rel-row { border-top: 1px solid #f0f2f5; }

/* Thumbnail */
.rel-thumb {
  position: relative;
  flex-shrink: 0;
  width: 112px;
  height: 68px;
  border-radius: 5px;
  overflow: hidden;
  background: #000;
  line-height: 0;
}
.rel-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: opacity .2s;
}
.rel-row:hover .rel-thumb img { opacity: .88; }

/* Play overlay on related thumb */
.rel-play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.rel-play-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(0,0,0,.52);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 10px;
}

/* Duration badge */
.rel-dur {
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: rgba(0,0,0,.72);
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 4px;
  border-radius: 2px;
  pointer-events: none;
  letter-spacing: .2px;
}

/* Text side of related row */
.rel-info { flex: 1; min-width: 0; }
.rel-title {
  font-size: 13px;
  font-weight: 600;
  color: #1b2e4b;
  line-height: 1.4;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.rel-channel {
  font-size: 12px;
  color: #596882;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  gap: 3px;
}
.rel-meta { font-size: 11px; color: #97a3b9; }

/* Verified tick */
.verified-icon {
  color: #596882;
  font-size: 10px;
  vertical-align: middle;
}

/* ══════════════════════════════════════════════
   8.  RESPONSIVE BREAKPOINTS
══════════════════════════════════════════════ */

/* ── md 768–991px: sidebar stacks below, goes full width ── */
@media (max-width: 991px) {
  .layout-col-main  { width: 100% !important; max-width: 100% !important; flex: 0 0 100% !important; padding-right: 0 !important; }
  .layout-col-aside { width: 100% !important; max-width: 100% !important; flex: 0 0 100% !important; margin-top: 20px; padding-left: 0 !important; }

  /* Related panel: switch from vertical list to 2-col grid */
  .related-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0;
  }
  .rel-row + .rel-row { border-top: none; }
  .related-grid .rel-row { border: 1px solid #f0f2f5; }
}

/* ── sm 576–767px ── */
@media (max-width: 767px) {
  body { padding: 0 !important; }
  .page-wrap { padding: 0 12px 40px !important; }

  .rel-thumb { width: 96px; height: 58px; }
  .related-grid { grid-template-columns: 1fr; }
  .related-grid .rel-row { border: none; }
  .related-grid .rel-row + .rel-row { border-top: 1px solid #f0f2f5; }
}

/* ── xs <576px ── */
@media (max-width: 575px) {
  .page-wrap { padding: 0 8px 40px !important; }
  .video-card { border-radius: 6px; }
  .video-embed-wrap { border-radius: 6px 6px 0 0; }

  .rel-thumb { width: 88px; height: 52px; }
  .rel-title { font-size: 12px; }

  /* Reaction bar wraps on tiny screens */
  .reaction-bar { flex-wrap: wrap; row-gap: 8px; }

  /* Comment input row tighter */
  .comment-input-row { padding: 12px; gap: 8px; }
}

/* Touch: kill hover effects */
@media (hover: none) {
  .sug-card:hover  { box-shadow: none !important; transform: none !important; }
  .rel-row:hover   { background: transparent; }
}
</style>
